import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { rgba } from 'polished';
import { theme } from '../../styles/config/theme';
import { typeStyle } from '../../styles/config/typeStyles';
import { StyledWrapper } from '../common/Wrapper/Wrapper.styles';

const StyledSection = styled.section`
  margin-top: 26px;
  padding-bottom: 21px;
  border-bottom: 1px solid ${rgba(theme.color.white, 0.1)};

  ${StyledWrapper} {
    padding: 0 14px;
  }
`;

const StyledList = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
`;

const StyledListItem = styled.li`
  width: 100%;
  max-width: 150px;
  margin: 0 11.5px 10px 11.5px;
  list-style-type: none;
`;

const StyledLink = styled(Link)`
  width: 100%;
  display: inline-block;
  padding: 0 0 17px 0;
`;

const StyledImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 150px;
  margin-bottom: 12px;
  border-radius: 4px;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      180deg,
      ${rgba(theme.color.black, 0.2)} 21.28%,
      ${rgba(theme.color.black, 0.8)} 100%
    );
  }
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const StyledTitle = styled.h2`
  width: 100%;
  padding: 0 5px;
  ${typeStyle.h3};
  text-transform: uppercase;
  letter-spacing: 0.56px;
`;

export {
  StyledWrapper,
  StyledSection,
  StyledImageWrapper,
  StyledImage,
  StyledList,
  StyledListItem,
  StyledLink,
  StyledTitle,
};
